import { gql } from 'graphql-request';

export const INIT_MUTATION = gql`
  mutation Init {
    init {
      status
      statusCode
      message
      errorCode
      data {
        publicKey
      }
    }
  }
`;

export const IDENTIFY_LOGIN_METHOD_MUTATION = gql`
  mutation IdentifyLoginMethod($email: String!) {
    identifyLoginMethod(email: $email) {
      status
      statusCode
      message
      errorCode
      data {
        authMethod
        redirectUrl
      }
    }
  }
`;

export const SIGNUP_MUTATION = gql`
  mutation Signup($email: String!) {
    signup(email: $email) {
      status
      statusCode
      message
      errorCode
      data {
        otpKey
        resendReadyTime
        sourceType
        source
        user
      }
    }
  }
`;

export const FORGOT_PASSWORD_MUTATION = gql`
  mutation ForgotPassword($email: String!) {
    forgotPassword(email: $email) {
      status
      statusCode
      message
      errorCode
      data {
        otpKey
        resendReadyTime
        sourceType
        source
        user
      }
    }
  }
`;

export const RESEND_OTP_MUTATION = gql`
  mutation ResendOtp($input: ResendOtpInput!) {
    resendOtp(input: $input) {
      status
      statusCode
      errorCode
      message
      data {
        resendAttemptsCount
      }
    }
  }
`;

export const VERIFY_OTP_MUTATION = gql`
  mutation VerifyOtp($input: VerifyOtpInput!) {
    verifyOtp(input: $input) {
      status
      statusCode
      message
      errorCode
      data {
        accessToken
        resendReadyTime
        source
        sourceType
        user
        otpKey
        redirectionData {
          viewIdentifier
          processIdentifier
          subProcessIdentifiers
        }
      }
    }
  }
`;

export const SET_PASSWORD_MUTATION = gql`
  mutation SetPassword($input: SetPasswordInput!) {
    setPassword(input: $input) {
      status
      statusCode
      errorCode
      message
      data {
        accessToken
        redirectionData {
          viewIdentifier
          processIdentifier
          subProcessIdentifiers
        }
      }
    }
  }
`;

export const CHECK_EXISTING_SESSION_QUERY = gql`
  query CheckExistingSession {
    checkExistingSession {
      status
      statusCode
      message
      errorCode
      data {
        redirection {
          viewIdentifier
          processIdentifier
          subProcessIdentifiers
        }
        selectMerchant {
          mid
          brandName
        }
      }
    }
  }
`;

export const LOGIN_MUTATION = gql`
  mutation Login($input: LoginInput!) {
    login(input: $input) {
      status
      statusCode
      message
      errorCode
      data {
        accessToken
        redirectionData {
          viewIdentifier
          processIdentifier
          subProcessIdentifiers
        }
        otpKey
        resendReadyTime
        source
        sourceType
        user
      }
    }
  }
`;
